import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateOptionItemSprite,
  DominateOptionItemSpriteList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateOptionItemSprite';
import { CONTROL_STYLE_OPTIONS } from '@/pages/Onboarding/options/ControlStyle/CONTROL_STYLE_OPTIONS';
import { ControlStyleOptionIdType } from '@/pages/Onboarding/options/ControlStyle/types';
import { getControlStyleTitleById } from '@/pages/Onboarding/options/ControlStyle/utils/getControlStyle';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './ControlStyle.styles';

export const ScreenControlStyle: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ControlStyle',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const controlStyle = form.watch('control_style');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['control_style']>,
  ) => {
    form.setValue('control_style', option.id);
  };

  const getImageSrc = (id: OnbOptionType<ControlStyleOptionIdType>['id']) => {
    return `/assets/layout-own-ai-dominate/control_style/${id}.png`;
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        control_style: getControlStyleTitleById(controlStyle),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>What kind of control do you crave?</OwnAiTitle>

      <IonContent>
        <DominateOptionItemSpriteList>
          {CONTROL_STYLE_OPTIONS.map((option) => (
            <DominateOptionItemSprite
              key={option.id}
              alt="control style"
              isSelected={controlStyle === option.id}
              onClick={() => handleSelect(option)}
              spriteSrc={getImageSrc(option.id)}
              title={option.title}
              TEST_ID={`control-style-${option.id}`}
            />
          ))}
        </DominateOptionItemSpriteList>
      </IonContent>

      {controlStyle && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
        />
      )}
    </PageStyles>
  );
};
